import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

/**
 * Componente que representa um balão informativo.
 */
@Component({
    selector: "nms-popover[popoverId]",
    template: `
        <div class="nms-popover" id={{popoverId}}>
            <span class="close-btn" (click)="closePopover()">&times;</span>
            <h4>{{ subject | translate }}</h4>
            <p>{{ description | translate }}</p>
        </div>
    `,
    styleUrls: ["./nms-popover.component.scss"]
})
export class NmsPopoverComponent implements OnInit {

    @Input() popoverId: string;
    @Input() subject: string;
    @Input() description: string;

    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit(): void {
        if (!this.popoverId) {
            throw new Error("O input 'popoverId' não pode ser vazio.");
        }

        if (!this.subject || !this.description) {
            throw new Error("Os inputs 'subject' e 'description' devem ser preenchidos.");
        }
    }

    closePopover(): void {
        this.onClose.emit();
    }

}
